"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=void 0;function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_nonIterableRest()}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function _iterableToArrayLimit(arr,i){if(!(Symbol.iterator in Object(arr)||Object.prototype.toString.call(arr)==="[object Arguments]")){return}var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break}}catch(err){_d=true;_e=err}finally{try{if(!_n&&_i["return"]!=null)_i["return"]()}finally{if(_d)throw _e}}return _arr}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true})}else{obj[key]=value}return obj}function getUa(){if(typeof navigator!=="undefined"){if(typeof navigator.userAgent!=="undefined"){return navigator.userAgent}}return""}// export class Device {
//     /**
//      * @description 手机h5
//      * @memberof Device
//      */
//     public isH5 = /(Android|iPhone|iPad|iPod|iOS|Windows Phone)/i.test(getUa());
//     /**
//      * @description 手Q
//      * @memberof Device
//      */
//     public isQQ = /\b(V1_AND_SQI?_([\d\.]+))|(.*? QQ\/([\d\.]+))/.test(getUa());
//     /**
//      * @description 手Q公众号（注：仅android下有效，iOS下无法区分是否公众号）
//      * @memberof Device
//      */
//     public isQQPA = /.*? PA QQ\/([\d\.]+)/.test(getUa());
//     /**
//      * @description 微信
//      * @memberof Device
//      */
//     public isWX = /\bMicroMessenger\/([\d\.]+)/.test(getUa());
//     /**
//      * @description iOS
//      * @memberof Device
//      */
//     public isIOS = /(iPad|iPhone|iPod).*? (IPad)?/.test(getUa());
//     /**
//      * @description Android
//      * @memberof Device
//      */
//     public isAndroid = /\bandroid/i.test(getUa());
//     /**
//      * @description QQBrowser
//      * @memberof Device
//      */
//     public isQQBrowser = /\bMQQBrowser\/([\d\.]+)/.test(getUa());
//     /**
//      * @description nowDev
//      * @memberof Device
//      */
//     public isNowDev = /\bNow\/([\d\._]+|LocalCompiled)\s*tnowDailybuild/.test(getUa());
//     /**
//      * @description now
//      * @memberof Device
//      */
//     public isNow = /\bNow\/([\d\._]+|LocalCompiled)/.test(getUa());
//     /**
//      * @description now结合版
//      * @memberof Device
//      */
//     public isNowSDK = /\bNowSDK\/([\d\.]*)/i.test(getUa());
//     /**
//      * @description Qzone
//      * @memberof Device
//      */
//     public isQzone = /\bQzone\/\w*_([\d\.]+)/.test(getUa());
//     /**
//      * @description 微博
//      * @memberof Device
//      */
//     public isWeibo = /\bweibo/i.test(getUa());
//     /**
//      * @description 应用宝
//      * @memberof Device
//      */
//     public isYYB = /\/qqdownloader\/(\d+)(?:\/(appdetail|external))?/.test(getUa());
//     /**
//      * @description 动漫
//      * @memberof Device
//      */
//     public isComicReader = /\bQQAC_Client(_\w+)?\/([\d\.]*)/i.test(getUa());
//     /**
//      * @description PC 的 QQ
//      * @memberof Device
//      */
//     public isPCQQBrowser = /\bQQBrowser\/([\d\.]+)/.test(getUa());
//     /**
//      * @description 百万闯关
//      * @memberof Device
//      */
//     public isNowOpenSDK = /\bNowOpenSdk\/([\d\.]*)/i.test(getUa());
//     public isHuayang = /\bhuayangapp\/([\d\.]*)/.test(getUa());
//     public isJiaoyou = /\bODApp\/([\d\.]+|LocalCompiled)/.test(getUa());
//     public isJiaoyouDev = /\bODApp\/LocalCompiled/.test(getUa());
// }
// const device = new Device();
// export default device;
var regexp=[["IOS",/\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,2],["android",/\bAndroid\s*([^;]+)/],["QQBrowser",/\bMQQBrowser\/([\d\.]+)\s(?!TBS\/([\d]+))(\w+)/],["nowSDK",/\bNowSDK\/([\d\.]*)/i],// now结合版
["QQ",/\bQQ\/([\d\.]+)/],["weixin",/\bMicroMessenger\/([\d\.]*)/],["now",/\bNow\/([\d\._]+|LocalCompiled)/],["nowDev",/\bNow\/([\d\._]+|LocalCompiled)\s*tnowDailybuild/],["jiaoyou",/\bODApp\/([\d\.]+|LocalCompiled)/],["jiaoyouDev",/\bODApp\/LocalCompiled/],["huayang",/\bhuayangapp\/([\d\.]*)/],["qzone",/\bQzone\/\w*_([\d\.]+)/],["PCQQBrowser",/\bQQBrowser\/([\d\.]+)/],// PC 的 QQ
["nowOpenSDK",/\bNowOpenSdk\/([\d\.]*)/i],// 百万闯关
["comicReader",/\bQQAC_Client(_\w+)?\/([\d\.]*)/i],// 动漫
["weibo",/\bweibo/i],// 微博
["YYB",/\/qqdownloader\/(\d+)(?:\/(appdetail|external))?/],// 应用宝
["TencentLive",/\bTencentLive\/([\d\.]*)/i]// 腾讯直播
];function Up(str){return str.replace(/^./,function(ch){return ch.toUpperCase()})}var Device=/*#__PURE__*/function(){function Device(){_classCallCheck(this,Device);_defineProperty(this,"entry",{});this._init()}/**
     * 获取版本
     * @param {String} keyword
     * @return {String}
     */_createClass(Device,[{key:"version",value:function version(name){return this.entry[name+"Version"]||null}},{key:"_init",value:function _init(){var _this=this;regexp.forEach(function(args){_this.addItem.apply(_this,args)});this.entry.platform=this.entry.isIOS?"ios":this.entry.isAndroid?"android":"pc";regexp.forEach(function(args){var _args=_slicedToArray(args,1),name=_args[0];if(_this.entry["is"+Up(name)]){_this.entry.type=name}});// 网络类型
this.entry.netType=getUa().match(/NetType\/(\w+)/i)&&RegExp.$1.toUpperCase();// 机型，主要是安卓机型，例如 HUAWEI C8825D，SAMSUNG-GT-I9308_TD 等
this.entry.model=getUa().match(/\(.*;\s?(\S*?\s?\S*?)\s?(Build)?\//i)&&RegExp.$1;this.entry.userAgent=getUa}},{key:"addItem",value:function addItem(name,exp){var verPos=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var match=getUa().match(exp);var version=(match&&match[verPos]||"").replace(/_/g,".")||null;this.entry["is"+Up(name)]=!!match;this.entry[name+"Version"]=version;this.entry[name+"Upper"]=this._upper.bind(this,name);this.entry[name+"Lower"]=this._lower.bind(this,name);this.entry[name+"Compare"]=this._compare.bind(this,name)}},{key:"_upper",value:function _upper(name,ver){var v=this.version(name);return v&&this.compare(v,ver)>=0||false}},{key:"_lower",value:function _lower(name,ver){var v=this.version(name);return v&&this.compare(v,ver)<=0||false}},{key:"_compare",value:function _compare(name,ver){var v=this.version(name);return v?this.compare(v,ver):-2}/*
     * 当a<b返回-1, 当a==b返回0, 当a>b返回1,
     * 约定当a或b非法则返回-1
     *
     * ps：该方法从qqapi.js中移植过来的
     */},{key:"compare",value:function compare(a,b){var i;var l;var r;var len;var a1;var b1;a1=String(a).split(".");b1=String(b).split(".");for(i=0,len=Math.max(a.length,b.length);i<len;i++){l=isFinite(a1[i])&&Number(a1[i])||0;r=isFinite(b1[i])&&Number(b1[i])||0;if(l<r){return-1}else if(l>r){return 1}}return 0}}]);return Device}();var _default=new Device().entry;exports["default"]=_default;